namespace Areas.Report {
    "use strict";


    export function gotoInspectionReport() {
        var dataGrid = $('#InspectionGrid').dxDataGrid('instance');
        let inspectionId = dataGrid.getSelectedRowKeys()[0];

        if (inspectionId != null) {
            const url = `/Custom/Report/Inspection/${inspectionId}`;
            window.open(url);
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }

    }   

    export function gotoInspectionReportMultiple() {
        var dataGrid = $('#InspectionGrid').dxDataGrid('instance');
        let inspectionIds = dataGrid.getSelectedRowKeys();

        if (inspectionIds != null) {
            const url = `/Custom/Report/InspectionMultiple/${inspectionIds}`;
            window.open(url);
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }

    }   

    export function gotoInspectionReportAll() {
        var dataGrid = $('#InspectionGrid').dxDataGrid('instance');
        var inspectionProjectId = dataGrid.option("InspectionProjectId");

        if (inspectionProjectId != null) {
            const url = `/Custom/Report/InspectionAll/${inspectionProjectId}`;
            window.open(url);
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }

    }   

    export function gotoInspectionReportFromForm() {
        var form = $('#InspectionsForm').dxForm('instance');
        let keyId: any = form.option('InspectionId');
        if (keyId != null) {
            const url = `/Custom/Report/Inspection/${keyId}`;
            window.open(url);
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }
    } 

    export function gotoNonComplianceReport() {
        var dataGrid = $('#NonCompliancesGrid').dxDataGrid('instance');
        let nonComplianceId = dataGrid.getSelectedRowKeys()[0];

        if (nonComplianceId != null) {
            const url = `/Custom/Report/NonCompliance/${nonComplianceId}`;
            window.open(url);
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }

    }

    export function gotoNonComplianceReportMultiple() {
        var dataGrid = $('#NonCompliancesGrid').dxDataGrid('instance');
        let nonComplianceIds = dataGrid.getSelectedRowKeys();

        if (nonComplianceIds != null) {
            const url = `/Custom/Report/NonComplianceMultiple/${nonComplianceIds}`;
            window.open(url);
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }

    }

    export function gotoNonComplianceReportAll() {
        var dataGrid = $('#NonCompliancesGrid').dxDataGrid('instance');
        var inspectionProjectId = dataGrid.option("InspectionProjectId");

        if (inspectionProjectId != null) {
            const url = `/Custom/Report/NonComplianceAll/${inspectionProjectId}`;
            window.open(url);
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }

    }

    export function gotoNonComplianceReportFromForm() {
        var form = $('#NonCompliancesForm').dxForm('instance');
        let nonComplianceId: any = form.option('KeyId');
        if (nonComplianceId != null) {
            const url = `/Custom/Report/NonCompliance/${nonComplianceId}`;
            window.open(url);
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }
    } 

    export function gotoObservationReport() {
        var dataGrid = $('#ObservationGrid').dxDataGrid('instance');
        let observationId = dataGrid.getSelectedRowKeys()[0];

        if (observationId != null) {
            const url = `/Custom/Report/Observation/${observationId}`;
            window.open(url);
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }

    }

    export function gotoObservationReportMultiple() {
        var dataGrid = $('#ObservationGrid').dxDataGrid('instance');
        let observationIds = dataGrid.getSelectedRowKeys();

        if (observationIds != null) {
            const url = `/Custom/Report/ObservationMultiple/${observationIds}`;
            window.open(url);
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }

    }

    export function gotoObservationReportAll() {
        var dataGrid = $('#ObservationGrid').dxDataGrid('instance');
        var inspectionProjectId = dataGrid.option("InspectionProjectId");

        if (inspectionProjectId != null) {
            const url = `/Custom/Report/ObservationAll/${inspectionProjectId}`;
            window.open(url);
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }

    }

    export function gotoObservationReportFromForm() {
        var form = $('#ObservationsForm').dxForm('instance');
        let observationId: any = form.option('KeyId');
        if (observationId != null) {
            const url = `/Custom/Report/Observation/${observationId}`;
            window.open(url);
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }
    } 

    export function gotoDailyReport() {
        var dataGrid = $('#DailyReportGrid').dxDataGrid('instance');
        let dailyId = dataGrid.getSelectedRowKeys()[0];

        if (dailyId != null) {
            const url = `/Custom/Report/Dailies/${dailyId}`;
            window.open(url);
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }
    }

    export function gotoDailyReportMultiple() {
        var dataGrid = $('#DailyReportGrid').dxDataGrid('instance');
        let dailyIds = dataGrid.getSelectedRowKeys();

        if (dailyIds != null) {
            const url = `/Custom/Report/DailiesMultiple/${dailyIds}`;
            window.open(url);
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }

    }

    export function gotoDailyReportAll() {
        var dataGrid = $('#DailyReportGrid').dxDataGrid('instance');
        var inspectionProjectId = dataGrid.option("InspectionProjectId");

        if (inspectionProjectId != null) {
            const url = `/Custom/Report/DailiesAll/${inspectionProjectId}`;
            window.open(url);
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }
    }

    export function gotoDailyReportFromForm() {
        var form = $('#DailiesForm').dxForm('instance');
        let dailyId: any = form.option('KeyId');
        if (dailyId != null) {
            const url = `/Custom/Report/Dailies/${dailyId}`;
            window.open(url);
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }
    } 
}



